export enum ProductInventoryWorkspaceCapabilityAccessOperation {
    create = "65eea64a-bb96-405f-9404-a859ce5f5705",
    read = "19d39884-db50-4882-b27c-de3eba8c07ae",
    update = "78fd8fc8-ca3b-46a0-8dfe-cca64733f2d7",
    delete = "5312d8c5-60ac-48d7-bf6a-ec4d39fdf05d",
}
